import locales from 'locales';
import {notify} from '../utils/desktopNotifications';
import {NEW_CHAT_SOUND_BLOCKED} from '../services/notification/soundWarning';

const soundMiddleware = store => next => action => {
    if (action.type === 'PLAY_NEW_SYSTEM_NOTIFICATION_SOUND') {
        const audio = new Audio('/mp3/new-notification.mp3');
        audio.play().catch(err => console.warn('Sound play failed', err));
    }

    /* the saga raises this one only for a chat given to this operator */
    if (action.type === 'NEW_CHAT_FOR_OPERATOR') {
        if (!action.payload || action.payload.sound !== false) {
            const audio = new Audio('/mp3/new-chat.mp3');
            audio.play().catch(err => {
                console.warn('Sound play failed', err);
                if (err.name === 'NotAllowedError') {
                    console.info('Showing warning modal to operator');
                    store.dispatch({type: NEW_CHAT_SOUND_BLOCKED});
                }
            });
        }

        announce(store, action);
    }

    if (action.type === 'PLAY_NEW_MESSAGE_SOUND') {
        const audio = new Audio('/mp3/new-message.mp3');
        audio.play().catch(err => console.warn('Sound play failed', err));
    }

    return next(action);
};

function announce(store, action) {
    const payload = action.payload;
    if (!payload) return;

    const user = store.getState().user;
    if (!user || !user.id) return;

    /*
     * The dictionary straight from locales rather than through Translate: that
     * component reaches for the store, which is the module this middleware is
     * built into, and the two would import each other.
     */
    const dictionary = locales[user.language] || {};

    const name = payload.name && payload.name.trim() !== ''
        ? payload.name
        : dictionary.visitor;

    notify(user.id, {
        title: name,
        /* a chat of one's own, or one handed over by somebody */
        body: dictionary[payload.bodyKey] || dictionary.newConversationReceived,
        /* one per chat, so two chats in a row do not become one entry */
        tag: 'conversation-' + payload.conversationId,
        /* and clicking it goes to that chat, rather than to wherever the panel was */
        conversationId: payload.conversationId,
    });
}

export default soundMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/soundMiddleware.js